export type Environment = 'local' | 'development' | 'staging' | 'production';

export interface EnvironmentConfig {
  apiUrl: string;
  useMockData: boolean;
}

const environments: Record<Environment, EnvironmentConfig> = {
  local: {
    apiUrl: import.meta.env.VITE_API_URL || 'https://da937e6cc6b7.ngrok.app',
    useMockData: false
  },
  development: {
    apiUrl: import.meta.env.VITE_API_URL || 'https://da937e6cc6b7.ngrok.app',
    useMockData: false
  },
  staging: {
    apiUrl: import.meta.env.VITE_API_URL || 'https://da937e6cc6b7.ngrok.app',
    useMockData: false
  },
  production: {
    apiUrl: import.meta.env.VITE_API_URL || 'https://da937e6cc6b7.ngrok.app',
    useMockData: false
  }
};

const getCurrentEnvironment = (): Environment => {
  const env = import.meta.env.VITE_APP_ENV as Environment || 'local';
  if (!environments[env]) {
    console.warn(`Invalid environment ${env}, falling back to local`);
    return 'local';
  }
  return env;
};

export const getEnvironmentConfig = (): EnvironmentConfig => {
  const environment = getCurrentEnvironment();
  return environments[environment];
};
